<template>
  <v-row>
    <v-col lg="12">
      <s-crud
        ref="crudRef"
        :config="config"
        title="Solicitudes de Firma"
        :filter="filter"
        add
        :edit="canModify"
        :remove="canModify"
        searchInput
        @save="handleGuardar"
        @rowSelected="handleRowSelected"
      >
        <!-- === FILTROS === -->
        <template v-slot:filter>
          <v-container class="mb-4">
            <v-row>
              <v-col cols="12" md="4" class="s-col-form">
                <s-date
                  label="Fecha Inicio"
                  v-model="filter.BeginDate"
                  clearable
                ></s-date>
              </v-col>
              <v-col cols="12" md="4" class="s-col-form">
                <s-date
                  label="Fecha Fin"
                  v-model="filter.EndDate"
                  clearable
                ></s-date>
              </v-col>
              <v-col cols="12" md="4" class="s-col-form">
                <s-select
                  label="Estado"
                  :items="statusItems"
                  v-model="filter.SignatureStatus"
                  clearable
                ></s-select>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <!-- === FORMULARIO === -->
        <template slot-scope="props">
          <v-container v-if="props.item != null">
            <v-row>
              <v-col cols="12" md="4" class="s-col-form mt-2">
                <s-toolbar-person
                  noCamera
                  noEdit
                  label="Usuario Atendido"
                  v-model="props.item.DocumentNumber"
                  @returnPerson="returnPerson($event, props.item)"
                />
              </v-col>

              <v-col cols="12" md="8" class="s-col-form mt-2">
                <s-text
                  readonly
                  label="Persona Seleccionada"
                  v-model="props.item.PersonName"
                >
                  <template v-slot:append-outer>
                    <v-icon
                      color="error"
                      style="margin-top: 4px; cursor: pointer"
                      @click="limpiarPersona(props.item)"
                    >
                      mdi-close-circle-outline
                    </v-icon>
                  </template>
                </s-text>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4" class="s-col-form">
                <s-select-definition
                  :def="1662"
                  label="Tipo de Documento"
                  v-model="props.item.TypeFileProcess"
                ></s-select-definition>
              </v-col>

              <v-col cols="12" md="8" class="s-col-form">
                <v-file-input
                  label="Archivo"
                  v-model="props.item.FileData"
                  accept=".pdf,application/pdf"
                  @change="handleFileChange($event, props.item)"
                  prepend-icon="mdi-file-pdf"
                  hide-details
                ></v-file-input>
                <p
                  v-if="props.item.FileName && !props.item.FileData"
                  class="text-caption text-muted ml-8 mt-2 mb-0"
                >
                  Archivo actual: {{ props.item.FileName }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <!-- === COLUMNAS PERSONALIZADAS === -->
        <template v-slot:SignatureStatus="{ row }">
          <v-chip
            dark
            small
            :color="row.SignatureStatus === 1 ? 'success' : 'warning'"
          >
            {{ row.SignatureStatus === 1 ? "Firmado" : "Pendiente" }}
          </v-chip>
        </template>

        <template v-slot:SecCreate="{ row }">
          <span v-if="row.SecCreate">{{ formatDateTime(row.SecCreate) }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:FileName="{ row }">
          <a
            href="#"
            @click.prevent="abrirVisorDocumento(row)"
            style="text-decoration: underline; color: #1976d2"
            v-if="row.FileName"
          >
            <v-icon small color="red">mdi-file-pdf-box</v-icon>
            {{ row.FileName }}
          </a>
        </template>

        <template v-slot:TypeFileProcessName="{ row }">
          <strong>{{ row.TypeFileProcessName || "Documento" }}</strong>
        </template>

        <template v-slot:CustomSignature="{ row }">
          <template v-if="row.SignatureStatus === 1">
            <v-btn
              icon
              small
              v-if="row.TypeDocumentSignature === 1 && row.SignatureBase64"
              @click="abrirModalFirma(row.SignatureBase64, 'DIBUJO')"
            >
              <v-icon color="blue">mdi-draw-pen</v-icon>
            </v-btn>
            <v-btn
              icon
              small
              v-else-if="row.TypeDocumentSignature === 2"
              @click="abrirModalFirma(null, 'HUELLA', row.SignatureDate)"
            >
              <v-icon color="green">mdi-fingerprint</v-icon>
            </v-btn>
          </template>
        </template>
      </s-crud>

      <!-- Modal Visor Firma -->
      <v-dialog v-model="signatureModalVisible" max-width="450">
        <v-card class="rounded-lg">
          <v-card-title class="headline grey lighten-2 font-weight-bold">
            <span style="color: #333">Firma del Documento</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="signatureModalVisible = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-title>
          <v-card-text class="text-center mt-5">
            <v-img
              v-if="signatureTypeView === 'DIBUJO' && signatureImage"
              :src="signatureImageBase64(signatureImage)"
              max-height="180"
              contain
              class="grey lighten-4 rounded border-1"
              style="border: 1px solid #e0e0e0"
            ></v-img>

            <div v-else-if="signatureTypeView === 'HUELLA'" class="py-5">
              <v-icon size="80" color="green darken-1">mdi-fingerprint</v-icon>
              <p
                class="mt-4 subtitle-1 font-weight-medium"
                style="color: #424242"
              >
                Documento firmado mediante validación biométrica del
                dispositivo.
              </p>
              <p
                v-if="signatureMeta"
                class="text-caption"
                style="color: #757575"
              >
                Fecha: {{ formatDateTime(signatureMeta) }}
              </p>
            </div>

            <p v-else style="color: #757575">
              No hay datos de firma disponibles.
            </p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Modal Visor PDF -->
      <v-dialog v-model="visorDocumentoVisible" max-width="95%" persistent>
        <v-card class="rounded-lg">
          <v-card-title class="headline grey lighten-2">
            <span
              style="color: #333; font-weight: 600; font-size: 1.1rem"
              class="text-truncate"
            >
              Visor de Documento:
              {{ documentoActual ? documentoActual.FileName : "" }}
            </span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              color="blue darken-1"
              @click="compartirDocumento"
              title="Descargar/Compartir"
              class="mr-2"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
            <v-btn icon @click="visorDocumentoVisible = false"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-title>
          <v-card-text style="height: 80vh; padding: 0">
            <iframe
              v-if="pdfLocalPath"
              :src="pdfLocalPath"
              width="100%"
              height="100%"
              style="border: none; background-color: #f8fafc"
            ></iframe>
            <v-container v-if="descargandoDocumento" fill-height>
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    size="64"
                  ></v-progress-circular>
                  <p class="mt-4 text--secondary">Descargando documento...</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import _DocumentSignatureService from "@/services/General/DocumentSignature.js";
import _HelperService from "@/services/HelperService.js";
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson.vue";

export default {
  components: { sToolbarPerson },
  data() {
    return {
      statusItems: [
        { text: "Todos", value: null },
        { text: "Pendientes", value: 0 },
        { text: "Firmados", value: 1 },
      ],
      filter: {
        BeginDate: null,
        EndDate: null,
        SignatureStatus: null,
        UsrCreateID: this.$fun.getUserID(),
      },
      selectedRow: null,

      // Modal Firma
      signatureModalVisible: false,
      signatureImage: null,
      signatureTypeView: null,
      signatureMeta: null,

      // Modal PDF
      visorDocumentoVisible: false,
      pdfLocalPath: null,
      documentoActual: null,
      descargandoDocumento: false,

      config: {
        service: _DocumentSignatureService,
        headers: [
          { text: "Documento", value: "TypeFileProcessName" },
          { text: "Fecha Emisión", value: "SecCreate" },
          { text: "Archivo", value: "FileName" },
          { text: "Firmante", value: "PersonName" },
          { text: "Estado", value: "SignatureStatus" },
          { text: "Firma", value: "CustomSignature" },
        ],
        model: {
          DtsID: "ID",
          SignatureDate: "datetime",
          SecCreate: "datetime",
        },
      },
    };
  },
  computed: {
    canModify() {
      return this.selectedRow ? this.selectedRow.SignatureStatus !== 1 : true;
    },
  },
  methods: {
    returnPerson(value, item) {
      if (value) {
        this.$set(item, "PersonName", value.NtpFullName);
        this.$set(item, "DocumentNumber", value.PrsDocumentNumber);
        this.$set(item, "PrsID", value.PrsID);
      }
    },
    limpiarPersona(item) {
      this.$set(item, "PersonName", null);
      this.$set(item, "DocumentNumber", null);
      this.$set(item, "PrsID", null);
    },
    handleRowSelected(selected) {
      if (selected && selected.length > 0) {
        this.selectedRow = selected[0];
      } else {
        this.selectedRow = null;
      }
    },
    handleFileChange(file, item) {
      if (file) {
        item.FileName = file.name;
        item.FileData = file;
      } else {
        item.FileName = null;
        item.FileData = null;
      }
    },
    abrirModalFirma(base64, tipo, meta = null) {
      this.signatureImage = base64;
      this.signatureTypeView = tipo;
      this.signatureMeta = meta;
      this.signatureModalVisible = true;
    },
    signatureImageBase64(base64Str) {
      if (!base64Str) return "";
      if (base64Str.includes("data:image")) return base64Str;
      return `data:image/png;base64,${base64Str}`;
    },
    formatDateTime(dateStr) {
      if (!dateStr) return "";
      try {
        const d = new Date(dateStr);
        return d.toLocaleString("es-ES");
      } catch (e) {
        return dateStr;
      }
    },
    sanitizarNombreArchivo(nombre) {
      return nombre.replace(/[^a-zA-Z0-9.\-_]/g, "_");
    },
    generarNombreUnico(nombreOriginal) {
      const now = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(
        now.getDate(),
      )}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(
        now.getSeconds(),
      )}`;

      const dotIndex = nombreOriginal.lastIndexOf(".");
      const baseName =
        dotIndex > 0
          ? this.sanitizarNombreArchivo(nombreOriginal.substring(0, dotIndex))
          : this.sanitizarNombreArchivo(nombreOriginal);
      const extension =
        dotIndex > 0 ? nombreOriginal.substring(dotIndex) : ".pdf";
      return `${baseName}_${timestamp}${extension}`;
    },
    async abrirVisorDocumento(item) {
      if (this.descargandoDocumento) return;

      // Cleanup de URL anterior
      if (this.pdfLocalPath) {
        URL.revokeObjectURL(this.pdfLocalPath);
        this.pdfLocalPath = null;
      }

      this.descargandoDocumento = true;
      this.documentoActual = item;
      this.visorDocumentoVisible = true;

      try {
        const response = await _HelperService.download(
          item.FileName,
          this.$fun.getUserID(),
        );
        const blob = new Blob([response.data], { type: "application/pdf" });
        this.pdfLocalPath = URL.createObjectURL(blob);
      } catch (error) {
        this.$fun.alert(
          "El documento no está disponible en este momento.",
          "warning",
        );
        this.visorDocumentoVisible = false;
      } finally {
        this.descargandoDocumento = false;
      }
    },
    compartirDocumento() {
      if (!this.pdfLocalPath || !this.documentoActual) return;
      const link = document.createElement("a");
      link.href = this.pdfLocalPath;
      link.download = this.documentoActual.FileName || "documento.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async handleGuardar(rowWithSave) {
      if (!rowWithSave.PrsID) {
        this.$fun.alert(
          "Debes seleccionar a una persona solicitante.",
          "warning",
        );
        return;
      }

      // Si es un File input de Vuetify
      const fileToUpload = rowWithSave.FileData;

      if (fileToUpload && fileToUpload instanceof File) {
        try {
          const nombreUnico = this.generarNombreUnico(
            fileToUpload.name || "documento.pdf",
          );
          let formData = new FormData();
          formData.append("files", fileToUpload, nombreUnico);

          await _HelperService.uploadfile(
            "AdvanceProducer",
            this.$fun.getUserID(),
            formData,
            3,
          );

          rowWithSave.FileName = nombreUnico;
        } catch (error) {
          console.error("Error al subir archivo:", error);
          this.$fun.alert(
            "No se pudo subir el archivo al servidor.",
            "warning",
          );
          return;
        }
      }

      // Invoca el guardado interno del Crud (similar a row.save en RN)
      if (typeof rowWithSave.save === "function") {
        rowWithSave.save((prevRow) => {
          const updatedRow = { ...prevRow, ...rowWithSave };
          delete updatedRow.FileData;
          return updatedRow;
        });
      }
    },
  },
};
</script>

<style scoped>
.text-muted {
  color: #6c757d;
}
.border-1 {
  border: 1px solid #ccc;
}
</style>
